import { render, staticRenderFns } from "./BayRItem.vue?vue&type=template&id=6587e5e6&scoped=true&"
import script from "./BayRItem.vue?vue&type=script&lang=js&"
export * from "./BayRItem.vue?vue&type=script&lang=js&"
import style0 from "./BayRItem.vue?vue&type=style&index=0&id=6587e5e6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6587e5e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\web\\V-LAB\\project\\bayes-vue2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6587e5e6')) {
      api.createRecord('6587e5e6', component.options)
    } else {
      api.reload('6587e5e6', component.options)
    }
    module.hot.accept("./BayRItem.vue?vue&type=template&id=6587e5e6&scoped=true&", function () {
      api.rerender('6587e5e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BayItem/coms/BayRItem.vue"
export default component.exports